import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import UpNext from './up-next';

class PersistentVideoBar extends Component {
    constructor(props) {
        super(props);
        this.barRef = React.createRef();
        this.videoPlaceholderRef = React.createRef();

        require('./persistent-video-bar.scss');
        //console.log("[PersistentVideoBar Component] props:", props);
    }
    shouldComponentUpdate(nextProps, nextState) {

        return nextProps.location.pathname !== this.props.location.pathname || nextProps.show != this.props.show || nextProps.height != this.props.height;
    }
    componentWillUnmount() {
        this.props.onDestroy();
    }
    componentDidUpdate(prevProps, prevState) {
        //console.log("[PersistentVideoBar Component] Update:", this.props);

        if (this.props.show === true && this.props.height == 0) {
            const { current } = this.barRef;
            window.setTimeout(() => {
                this.props.onAnimate(current.offsetHeight);
            }, 0)

        }
        if (this.props["up-next"] !== prevProps["up-next"]) {
            this.props.onUpdate(this.props["up-next"]);
        }
    }
    componentDidMount() {
        this.props.onReady(this.videoPlaceholderRef.current, this.props["up-next"]);

    }

    render() {
        const { show, className, "up-next": upNext } = this.props;
        let classes = cx({
            "persistent-video-bar": true,
            "is-ready": this.props.height != 0,
            "show": show
        })
        let placeholderCx = cx({
            "video-placeholder": true,
            "show": show
        })
        classes = `${classes} ${className}`.trim();

        return (
            <section>
                <div className={classes} ref={this.barRef}>
                    <div className="bar-container">
                        {this.props.children}
                        <div className="up-next-section">
                            <UpNext {...upNext} />
                        </div>
                    </div>
                </div>
                <div ref={this.videoPlaceholderRef } className={placeholderCx} ></div> 
            </section>
        )
    }
    static get propTypes() {
        return {
            show: PropTypes.bool,
            className: PropTypes.string,
            upNext: PropTypes.object,
            children: PropTypes.array,
            height: PropTypes.number,
            location: PropTypes.object,
            onDestroy: PropTypes.func,
            onAnimate: PropTypes.func,
            onUpdate: PropTypes.func,
            onReady: PropTypes.func,
            "up-next": PropTypes.object
        }
    }

    static get defaultProps() {
        return {
            show: false,
            className: "",
            upNext: null
        }
    }
}


export default PersistentVideoBar